import About from "./components/About";
import Community from "./components/Community";
import Developer from "./components/Developer";
import Footer from "./components/Footer";
import Hero from "./components/Hero";
import Navbar from "./components/Navbar";

function App() {
  return (
    <div className="">
      <Navbar />
      <Hero />
      <About />
      <Developer />
      <Community />
      <Footer />
    </div>
  );
}

export default App;
